<template>
  <div class="faculdade_breadcrumb2">
    <nav role="navigation">
      <ul class="breadcrumbsa">
        <Transition name="fade" v-for="crumb in breadcrumb">
          <li v-if="show">
            <a :href="crumb.url">
              {{ crumb.name }}
            </a>
          </li>
        </Transition>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "HeaderBreadcrumb",
  inject:["i18n","language"],
  data(){
    return {
      show: false,
    }
  },
  computed:{
    breadcrumb(){
      let baseurl = import.meta.env.VITE_APP_SITE_URL;
      if(this.language == "en"){
        baseurl = baseurl+"/en";
      }
      return [
        {name: "Homepage",url:import.meta.env.VITE_APP_SITE_URL},
        {name: this.$translate("UMA_LANG_FACULDADE_BREADCRUMB_SOBRE"),url:baseurl+"/sobre"},
        {name: this.$translate("UMA_LANG_FACULDADE_BREADCRUMB_FE"),url:baseurl+"/sobre/faculdades-e-escolas/"},
        {name: this.$store.state.faculdade?.nome,  url: "" }
      ]
    }
  },
  mounted() {
    this.show = true;
  }
}
</script>

<style scoped>

.fade-enter-active {
  opacity: 1;
  transition-property: opacity, transform;
  transition-duration: .8s, 1s;
  transition-timing-function: ease-in, ease-in;
  transition-delay: 0.2s, 0.2s;
}

.fade-enter-active:nth-of-type(2){
  transition-delay: .4s;
}

.fade-enter-active:nth-of-type(3){
  transition-delay: .6s;
}

.fade-enter-active:nth-of-type(4){
  transition-delay: .8s;
}

.fade-enter-from{
  opacity: 0;
}

/*
foi necessário copiar os estilos da breadcrumb do foundation e renomear a classe
porque entrava em conflito com uns da breadcrumb geral
*/
.breadcrumbsa {
  margin: 0 0 1rem;
  list-style: none;
}
.breadcrumbsa:after,
.breadcrumbsa:before {
  display: table;
  content: " ";
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-ordinal-group: 2;
  -ms-flex-order: 1;
  order: 1;
}
.breadcrumbsa:after {
  clear: both;
}
.breadcrumbsa li {
  float: left;
  font-size: 0.6875rem;
  color: #0a0a0a;
  cursor: default;
  text-transform: uppercase;
}
.breadcrumbsa li:not(:last-child):after {
  position: relative;
  top: 1px;
  margin: 0 0.75rem;
  opacity: 1;
  content: "/";
  color: #cacaca;
}
.breadcrumbsa a {
  color: #1779ba;
}
.breadcrumbsa a:hover {
  text-decoration: underline;
}
.breadcrumbsa .disabled {
  color: #cacaca;
  cursor: not-allowed;
}

.breadcrumbsa li{
  font-size: 15px;
  font-family: Montserrat;
  text-transform: none;
}

.breadcrumbsa li a {
  color: #a7a5a5;
}

.breadcrumbsa li a:hover {
  color: #c9c7c7;
}

/*fim estilos foundation*/

.faculdade_breadcrumb .breadcrumbsa li a{
  color: royalblue;
}

.faculdade_breadcrumb .breadcrumbsa li:after {
  color: royalblue;
}

.faculdade_breadcrumb li{
  font-family: 'Montserrat Bold';
  font-size: 16px;
  letter-spacing: 1.2px;
}

.faculdade_breadcrumb2 .breadcrumbsa li a{
  color: white;
}

.faculdade_breadcrumb2 .breadcrumbsa li:after {
  color: white;
}

.faculdade_breadcrumb2 li{
  font-size: 15px;
  font-family: Montserrat;
}

.faculdade_breadcrumb2{
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
}

/*952*/
.breadcrumbsa {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  white-space: nowrap;
}

.faculdade_breadcrumb2 .breadcrumbsa li a:hover {
  color: #b0afaf;
}





@media (min-width: 768px) and (max-width: 1024px){
  /*1117*/
  .breadcrumbsa li {
    font-size: 14px;
  }
}

@media (max-width: 767px){
  /*1428*/
  .breadcrumbsa{
    display: none;
  }
}
</style>